/**
 * The two login forms post to different endpoints with different identifier keys.
 * Everything that varies between them lives here, so the form itself stays a single
 * component and a third mode is a new entry rather than a new branch.
 */
export const LOGIN_MODES = {
  student: {
    heading: "Examination Login",
    label: "Application ID/Enrollment ID",
    placeholder: "Enter your college Application ID or Enrollment ID",
    endpoint: "/auth/student/login/",
    field: "identifier",
    type: "text",
    autocomplete: "off",
    route: { name: "Login", path: "/" },
  },
  admin: {
    heading: "Admin Login",
    label: "Email",
    placeholder: "Enter your email",
    endpoint: "/auth/login/",
    field: "email",
    type: "email",
    autocomplete: "off",
    route: { name: "AdminLogin", path: "/admin/login" },
  },
};

export const DEFAULT_LOGIN_MODE = "student";

export function loginMode(mode) {
  return LOGIN_MODES[mode] || LOGIN_MODES[DEFAULT_LOGIN_MODE];
}

/** Where a logged-out user of this mode belongs: the form they signed in through. */
export function routeForLoginMode(mode) {
  return loginMode(mode).route;
}

/** The auth endpoint this mode signs in against. */
export function endpointForLoginMode(mode) {
  return loginMode(mode).endpoint;
}
